import { Link, useLocation, useNavigate } from "react-router-dom";
import { Hbrbackarrow } from "./newComponents/Mycustomsvgicons";
import { useEffect, useRef } from "react";

const ReleaseNote = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const releaseType = queryParams.get("type");
  const androidReleaseLinkRef = useRef();

  const closePage = () => {
    if (location.state && location.state.from) {
      navigate(location.state.from);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    const timeId = setTimeout(() => {
      if (androidReleaseLinkRef.current) {
        androidReleaseLinkRef.current.click();
      }
    }, 3000);
    return () => clearTimeout(timeId);
  }, []);

  return releaseType === "android" ? (
    <main style={{ width: "100%", height: "100svh" }} className="flex-column2">
      <a
        href="https://Ransfordpappoe.github.io/hbr_android_release_note"
        target="_blank"
        rel="noreferrer"
        ref={androidReleaseLinkRef}
        style={{
          padding: "8px",
          backgroundColor: "white",
          borderRadius: "10px",
          textDecoration: "none",
          color: "--var(zoomBlue)",
        }}
      >
        Release Note Android - Click here to read.
      </a>
    </main>
  ) : (
    // <iframe
    //   src="https://Ransfordpappoe.github.io/hbr_android_release_note"
    //   width={"100%"}
    //   height={"100vh"}
    //   title="release note android"
    // >
    //   Release note android
    // </iframe>
    <div className="release-note">
      <div className="flex-row2" style={{ width: "100%", gap: "30px" }}>
        <Hbrbackarrow
          width={"2em"}
          height={"2em"}
          fillColour={"black"}
          handleClick={() => closePage()}
        />
        <h2>{`Release Note-April 20, 2024`}</h2>
      </div>

      <h3>hbrlite web version 2.24.4</h3>
      <h2>
        <strong>Last update:</strong> <em>9th December, 2024</em>
      </h2>
      <h3>
        <strong>Release details</strong>: Improved authentication system. Delay
        in authenticating users account have been fixed. Improved book retrieval
        time. Time elapsed to fetch a book content is improved to reduce loading
        time.
      </h3>

      <dl>
        <dt>Account Creation:</dt>
        <dd>
          You are required to create an account before using the app. Though
          some components of the app can be access without creating an account,
          account creation is required to regulate users who engage in sessions
          that require User generated contents. These include the chat room,
          divine blogs and in the live comment session where comments are
          allowed. Name and other few personal information is used solely to
          identify users and to take necessary actions if they default. Users
          can request their information be deleted which will result in the
          dissolution of account.
        </dd>{" "}
        <br />
        <br />
        <h3>Current Features and Usage: </h3> <br />
        <dt>Live session</dt>
        <dd>
          The “Live” session was created to stream live programs of horemow. To
          join Live programs, tap on the Live button to launch the Live
          component and wait for a few seconds for the live broadcast to finish
          setting up. An alert will show to indicate no live program in session
          in case there is none. While watching live programs, you are allowed
          to send comments and add screen reactions which will be displayed to
          other real time participants. Since user generated contents are
          allowed here, users without account won't be able to send comments
          directly to the live comment session. Any user without an account will
          be assigned a random user name and userID. Moreover, comments from
          random users will have to be approved by the host before displaying.
          This is done to prevent spamming the comment session. Users who have
          an account can interact on the live program without any restriction
          nevertheless the host can disable or enable interactions depending on
          the situation.
        </dd>{" "}
        <br />
        <br />
        <dt>ALL BOOKS:</dt>
        <dd>
          The all-books component currently contains Christian literatures
          written by Pastor Paul Rika of holiness revival movement. Books are
          available in English for now. Translation into other languages is
          underway. Internet connection is required to load and read books. The
          operation doesn't require strong internet connection. Users with weak
          internet connection can still have a good read. Download the mobile
          app to access offline reading features. A search view is implemented
          to filter and locate books with ease. Share books to your friends or
          loved ones to read inspired Godly books along with you. No need for
          them to download external pdf apps; they can read right from the link
          you share to them. Sharing books as PDF is only resrved to the mobile
          app version.
        </dd>{" "}
        <br />
        <br />
        <dt>CHAT ROOM: </dt>
        <dd>
          The purpose of the chat room is to provide a platform for readers to:{" "}
          <br />
          <br />
          share ideas or knowledge acquired from reading the books.
          <br /> Ask questions on portions of books read for clarification.{" "}
          <br />
          To connect believers together for Christian unity in doctrine and in
          character. <br />
          The chat room currently supports basic chat features: texts and
          images. More features will be added in later versions.
          <br />
          NB: You can use the report section to report anyone who exhibits
          inappropriate actions in the chat room. The report section is located
          on the header bar. For those using mobile phones and tablets, the
          report section is located in the list of options that appears when the
          menu bar is pressed.
        </dd>{" "}
        <br />
        <br />
        <dt>Divine Blogs: </dt>
        <dd>
          The divine Blogs is a platform designed and built by the team to
          promote Godly contents and writeups. Unlike other social networks, The
          divine Blogs is restricted to the promotion and creation of Godly
          contents void of antisemitism's. The following contents are not
          allowed in the Divine blogs: Hate comments or posts, sexual contents,
          promotion of spams. illegal or harmful drug contents, illicit ads or
          products, infringement on copyrighted contents, and other contents
          which may be unfit as determined by the administrators of the
          platform. Users who fail to adhere to the terms of use will be blocked
          and disallowed from posting new contents. Previous Contents of blocked
          users will be deleted. You are allowed to write a blog limited to 5000
          words. You can also attach a video or up to 6 images to your blog
          content. Video size is restricted to 40Mb. Short videos are restricted
          to 30Mb and a maximum video length of 3 minutes. Sharing, commenting,
          liking, saving, deleting and reporting functionalities are available
          to users while watching a short video content. The delete icon is only
          visible to the owner of the uploaded video content. Deleting short
          videos completely removes the video file and its associated meta data
          from the storage servers. This process cannot be undone so carefully
          consider your decision before deleting video contents. Since this is a
          public Christian social blog, users of the app can comment or share
          any uploaded video without restriction. For now, we have the right to
          generally control the sharing and commenting feature on a video
          content. We may extend this right to creators in later periods. The
          divine blogs is still in the basic stage of production. More features
          will be added to make the platform more robust and edifying. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>What can i post: </strong> <br />
          Aside sexual nudity and other illicit contents you can post Godly
          materials and other general contents like health tips, advisory
          contents, etc. In regards to health tips, make sure to provide
          references to your posts else your post will be deleted. These checks
          are strictly enforced due to the delicate nature of health issues. We
          strongly encourage you to attach pictures and references to any health
          material or content you post. Do not Post any material that is
          detriment to the psyche and well-being of users. Failure to abide by
          the rules will leave your user account terminated and deleted. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>Edit profile: </strong>
          It is advisable to update your profile especially when active in
          creating divine blogs. Other users will have the chance to view your
          profile and also share your contents for wider discovery. You are
          provided with the option to add an About text of yourself, add your
          social media handles for others to follow as well. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>Create Post: </strong>
          you can create a post by: <br /> 1. clicking on the{" "}
          <em>write your blog</em> holder located at the top of your feed.
          <br />
          2. On the left side bar click on create post <br />
          3. click on either attach video or attach picture located at the top
          of your feed. Maximum words allowed in your blog is limited to 5000.
          You can also attach a maximum of six images or a video to your blog
          write up. Only users with an account can create a post. Users who are
          not registered or blocked will only be allowed to read blogs on their
          feed. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>Send Comment </strong>
          Click on <em>Comment</em> to activate the comment section. Clicking on
          the blue colored <i>Comment </i>
          area will display the list of comments for a particular post. Blocked
          users or unregistered users are not allowed to comment. If you have
          registered and you are unable to send comments, contact the support
          team. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>Edified by a blog post: </strong>
          When edified or touched by a post, you can click on the Edified button
          to show your reaction to the content creator and other users. This
          will encourage the content creator to write more edifying blogs. The{" "}
          <em>edified</em> button is heart shaped enclosed in an open hands
          placed next to the <em>Comment</em> trigger. Clicking on the blue
          colored <i>edified</i> area will display the list of edified users for
          a particular post. <br />
          <br />
          <strong style={{ color: "#eb268f" }}>
            Delete Your Own Blog or comment:{" "}
          </strong>
          Click on the menu icon at the top right corner of the blog post. Click
          on <em>Delete</em> among the list of options in the drop down menu.{" "}
          <br />
          <br />
        </dd>{" "}
        <br />
        <br />
        <dt>Video and Audio sermons: </dt>
        <dd>
          The website is enriched with rich and life-transforming audio and
          video sermons from Holiness Revival Movement Worldwide. Sharing
          capabilities have been built into the video and audio player to allow
          sharing with friends and loved ones.
        </dd>{" "}
        <br />
        <br />
        <dt>AUDIO BOOKS: </dt>
        <dd>
          This is designed to help those who are visually impaired or
          individuals who finds it difficult to read.{" "}
        </dd>{" "}
        <br />
        <br />
        <dt>ONLINE RADIO: </dt>
        <dd>
          The Online radio was added to help you to connect to live services of
          Holiness Revival Movement Worldwide.{" "}
        </dd>{" "}
        <br />
        <br />
        <dt>Divine Assignment: </dt>
        <dd>
          The youth and adult assignment is given by the International Director
          - Pastor Paul Rika of Holiness Revival Movement Worldwide Also Known
          as Horemow. The divine assignment is given yearly for the Spiritual
          Growth and Soundness of Believers or Christians Worldwide. As a non -
          member of the movement using this website, you can voluntarily
          participate in this spiritual assignment. The assignment information
          is displayed in the Divine Assignment section.
        </dd>{" "}
        <br />
        <br />
        <dt>Technical Support: </dt>
        <dd>
          {`IF YOU FACE ANY TECHNICAL CHALLENGES CONTACT THE SUPPORT TEAM.`}
          <br />
        </dd>{" "}
        <br />
        <br />
        <Link
          to={`/contact`}
          style={{
            borderRadius: "10px",
            textDecoration: "none",
            backgroundColor: "white",
            padding: "5px",
            margin: "10px",
            fontWeight: "bold",
            borderLeft: "5px solid Teal",
            borderRight: "5px solid #ed268f",
          }}
        >
          Support Team
        </Link>
      </dl>
    </div>
  );
};
export default ReleaseNote;
